<template>
    <ContentOrLoading>
        <div class="row" v-if="!loading && svgRendered">
            <div class="col-12 text-center p-3">
                <div v-if="zona.tipo_svg == 1">
                    <SvgPanZoom 
                        class="svgpanzoom-container"
                        :zoomEnabled="true"
                        :controlIconsEnabled="false"
                        :fit="true"
                        :center="true"
                        :mouseWheelZoomEnabled="false"
                        :zoomScaleSensitivity="2"
                        :dblClickZoomEnabled="false"
                        :preventMouseEventsDefault="false"
                        @svgpanzoom="registerSvgPanZoom"
                    >
                        <svg v-html="svg_loaded"/>
                    </SvgPanZoom>
                    <div class="text-center" v-if="load_panzoom">
                        <button @click="zoomIn()" class="button panzoom-button">+</button>
                        <button @click="zoomOut()" class="button panzoom-button">-</button>
                    </div>
                    <b-popover
                        v-for="plaza in plazas"
                        :key="plaza.id"
                        :target="'popover-' + plaza.id" 
                        triggers="hover"
                    >
                        <div v-if="plaza.concepto"><strong>Concepto: </strong>{{ plaza.concepto }}</div>
                    </b-popover>
                </div>
                <LeafletComponent
                    v-else
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
            <leyenda-color-anexa/>
            <div class="col-12">
                <Button @click="selectAll">Seleccionar todas</Button>
                <Button class="m-3" @click="clearAll">Limpiar todas</Button>
            </div>

            <div class="col-12" v-if="!loading && plazas">   
                <div class="form-group">
                    <label>AFORO REGIÓN: {{ aforoTotal }}</label>
                </div>
                <div class="form-group">
                    <label>AFORO BLOQUEADO: {{ plazasBloqueadas }}</label>
                </div>
                <div class="form-group">
                    <label>AFORO A LA VENTA: {{ plazasLibres }}</label>
                </div>
            </div>

            <div class="col-12" v-if="!loading">
                <FormInput label="Concepto" v-model="concepto" />
            </div>
            <div class="col-12 my-3" v-if="!loading">
                <EtiquetaComponent @seleccionada="(etiquetaSeleccionada) => etiqueta = etiquetaSeleccionada" />
            </div> 
            <div class="col-12" v-if="!loading">
                <Button class="btn-lg btn-block" type="button" name="button" @click="bloquearAsientos" :disabled="bloquear_boton || bloqueando">Bloquear / Liberar</Button>
                <div class="col-12 text-center" v-if="bloqueando" style="height: 150px">
                    <LoaderComponent/>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import SvgPanZoom from 'vue-svg-pan-zoom';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import LeyendaColorAnexa from './LeyendaColorAnexa.vue';
    import EtiquetaComponent from '../../../../views/backend/events/sesiones/bloquear-asientos/EtiquetaComponent.vue';

    export default {
        props: ['zona'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                svgpanzoom: null,
                svg: null,
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red', 
                seleccionadaColor: '#8CA9D9',
                bloqueadaColor: '#BF95C4', 
                enSesionColor: 'yellow', 
                vendidaAbonosColor: 'red',
                vendidaEventosColor: 'black',
                bloqueadaEventosColor: 'purple', 
                enSesionEventosColor: 'orange', 
                abonadoNoRenovadoColor: '#B05D04',
                svgRendered: null,
                isPanning: false,
                plazas: null,
                plazasSeleccionadas: [],
                asientos: [],
                bloqueando: false,
                concepto: '',
            }            
        },
        created() {
            this.getButacas();
        },
        computed: {
            bloquear_boton() {
                return !(this.plazasSeleccionadas.length > 0);
            },
            plazasBloqueadas() {
                return this.plazas.filter(plaza => plaza.ocupada && plaza.ocupada.bloqueada).length;
            },

            plazasLibres() {
                return this.plazas.filter(plaza => plaza.libre).length;
            },

            aforoTotal() {
                return this.plazas.length;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            lista_id() {
                return this.$store.getters.getListaId;
            }
        },
        methods: {
            registerSvgPanZoom(svgpanzoom) {
                this.svgpanzoom = svgpanzoom;
            },
            zoomIn() {
                this.svgpanzoom.zoomIn();
            },
            zoomOut() {
                this.svgpanzoom.zoomOut();
            },
            getButacas() {
                this.loading = true;
                let params = {
                    filters: {},
                    lista_id: this.lista_id,
                    recinto_id: this.$store.getters.getRecinto.id,
                    region_id: this.zona.id
                }
                this.$store.dispatch(this.config.getVuexAlias('back.abonos.listado-butacas-region'), params).then( res => {
                    this.plazas = res.data.data
                    this.getSvg()
                });
            },
            getSvg() {
                this.loading = true;
                const params = {
                    region_id: this.zona.id,
                    recinto_id: this.$store.getters.getRecinto.id,
                };
                this.$store.dispatch(this.config.getVuexAlias('recinto.zona-svg'), params).then(({ data: { svg } }) => {
                    if (this.zona.tipo_svg == 1) {
                        this.loadSVG(svg);
                    } else if (this.zona.tipo_svg == 2) {
                        this.renderLeafletSvg(svg);
                    }

                    this.loading = false;
                }).catch(error => {
                    console.warn('Error al recuperar el SVG del recinto anexo');
                });
            },
            loadSVG(svg) {
                this.svg_loaded = svg;
                let vue_instance = this;
                setTimeout(() => {
                    let plazas = document.getElementsByClassName("recinto-zona");
                    for(let i in plazas) {
                        if(plazas[i].dataset !== undefined) {
                            let plaza_id = plazas[i].dataset.region;
                            for(let j in this.plazas) {
                                if (this.plazas[j].id == plaza_id) {
                                    if (!this.plazas[j].esta_disponible) {
                                        plazas[i].classList.add("plaza_ocupada");
                                    }
                                    if (this.plazas[j].esta_bloqueada) {
                                        plazas[i].classList.remove("plaza_ocupada");
                                        plazas[i].classList.add("plaza_bloqueada");
                                    }
                                }
                            }
                            plazas[i].addEventListener('click', function() {
                                vue_instance.clickRegion(this.dataset.region, plazas[i]);
                            }, false);
                        }                                                                                            
                    }
                }, 1000);                
            },
            clickRegion(plaza_id, plaza_svg = null) {
                let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
                if (plaza) {
                    if (plaza.esta_bloqueada && plaza_svg) {
                        plaza_svg.classList.toggle('plaza_bloqueada');
                    }
                    this.clickZona(plaza)
                }
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                    if (plaza) {
                        const title = this.getButacaName(plaza);

                        if (plaza.libre && !plaza.ocupada.bloqueada) {     
                            this.drawPopover(circle, plaza, title);      
                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickZona(plaza);
                                    }
                                }, 150);
                            });                    
                        } else if (plaza.ocupada && plaza.ocupada.bloqueada) {
                            if (plaza.info_ocupada && plaza.info_ocupada.concepto) {
                                let content = `<div><strong>Concepto: </strong>${plaza.info_ocupada.concepto}</div>`
                                this.drawPopover(circle, plaza, title, content);      
                            }
                            this.drawPopover(circle, plaza, title);    
                            circle.setAttribute('fill', this.bloqueadaColor);
                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.bloqueadaColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickZona(plaza);
                                    }
                                }, 150);
                            }); 
                        } else if (plaza.ocupada && plaza.ocupada.sesion) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.enSesionColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.venta) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaAbonosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.evento_bloqueo) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.bloqueadaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.evento_venta) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.info_ocupada.numero_abonado && plaza.ocupada.renovado) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.info_ocupada.numero_abonado && !plaza.ocupada.renovado) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.abonadoNoRenovadoColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        }  else if (plaza.ocupada && plaza.ocupada.evento_sesion) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.enSesionEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },

            drawPopover(circle, plaza, title = null, content = '') {

                if (plaza.ocupada) {
                    if (plaza.ocupada.bloqueada) {
                        content += `<div><strong>Plaza bloqueada</strong></div>`;
                    }
                    if (plaza.ocupada.venta) {
                        content += `<div><strong>Vendida</strong></div>`;
                    }
                    if (plaza.ocupada.sesion) {
                        content += `<div><strong>En sesión</strong></div>`;
                    }
                    if (plaza.ocupada.evento_venta) {
                        content += `<div><strong>Vendida en evento</strong></div>`;
                    }
                    if (plaza.ocupada.evento_bloqueo) {
                        content += `<div><strong>Bloqueada en evento</strong></div>`;
                    }
                    if (plaza.ocupada.evento_sesion) {
                        content += `<div><strong>En sesión en evento</strong></div>`;
                    }
                    if (plaza.info_ocupada.numero_abonado && !plaza.ocupada.renovado) {
                        content += `<div><strong>Abonado no renovado</strong></div>`;
                    }
                    if (plaza.info_ocupada.qr_abonado) {
                        content += `<div><strong>Código QR: ${plaza.info_ocupada.qr_abonado}</strong></div>`
                    }
                    if (plaza.info_ocupada.id_abonado) {
                        circle.style.cursor = 'pointer';
                        circle.addEventListener('click', () => {
                            let url = `/admin/abonados/${this.lista_id}/${plaza.info_ocupada.id_abonado}`;
                            window.open(url, '_blank');
                        });
                    }
                }

                if (plaza.libre) {
                    content = `<div><strong>Plaza libre</strong></div>`;
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                };

                new Popover(circle, popoverOptions);
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            clickZona(plazaSeleccionada) {
                const plazaEncontrada = this.plazas.find(plaza => plaza.id === plazaSeleccionada.id);

                if (plazaEncontrada) {
                    plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada; 

                    if (plazaEncontrada.seleccionada) {
                        if (!this.plazasSeleccionadas.some(plaza => plaza.id === plazaSeleccionada.id)) {
                            this.plazasSeleccionadas.push(plazaSeleccionada);
                            this.asientos.push(plazaSeleccionada.id);
                        }
                    } else {
                        const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id === plazaSeleccionada.id);
                        if (index !== -1) {
                            this.plazasSeleccionadas.splice(index, 1);
                            this.asientos.splice(index, 1);
                        }
                    }
                }
            },
            addToPlazasSeleccionadas(plazaSeleccionada) {
                if (!this.plazasSeleccionadas.some(plaza => plaza.id === plazaSeleccionada.id)) {
                    this.plazasSeleccionadas.push(plazaSeleccionada);
                }
            },

            updatePlazasSeleccionadas(plazaSeleccionada, isSelected) {
                if (isSelected) {
                    this.addToPlazasSeleccionadas(plazaSeleccionada);
                } else {
                    const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id === plazaSeleccionada.id);
                    if (index !== -1) {
                        this.plazasSeleccionadas.splice(index, 1);
                    }
                }
            },
            selectAll() {
                var plazas_formatted = this.plazas.filter(plaza => plaza.libre == true || plaza.libre == false && plaza.ocupada.bloqueada == true );
                plazas_formatted.forEach(plaza => {
                    this.clickZona(plaza);
                });            
            },
            clearAll() {
                this.asientos = [];
            
            },
            bloquearAsientos() {
                this.bloqueando = true;

                const params = {
                    filters: {},
                    lista_id: this.lista_id,
                    recinto_id: this.$store.getters.getRecinto.id,
                    butacas: this.asientos,
                };
                if (this.concepto && this.concepto.length > 0) {
                    params.concepto = this.concepto;
                }

                if(this.etiqueta){
                    params.etiqueta_bloqueo_id = this.etiqueta.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.bloquear.butacas'), params).then(res => {
                    this.concepto = '';
                    this.bloqueando = false;
                    this.asientos = [];
                    this.getButacas();
                    this.plazasSeleccionadas = [];
                });
            },
        },
        components: { SvgPanZoom, LeafletComponent, LeyendaColorAnexa, EtiquetaComponent }
    }
</script>

        